// extracted by mini-css-extract-plugin
export default {"inputRow":"StripeForm__inputRow___PSOx4","elementLabel":"StripeForm__elementLabel___Jd3cI","edit":"StripeForm__edit___F0WgV"};